/**
 * @Author:
 * @Description:
 * @DateTime: Created in 08:55 2019-07-10
 */

import {Component} from 'vue-property-decorator'
import CrcConfigService from "./service/crcConfigService"
import BasicSearchPage from "src/components/basicSearchPage/basicSearchPage";
import override from "src/dectorators/override";
import { CrcConfigDOI } from './api/crcConfigApi'

@Component
export default class CrcConfig extends BasicSearchPage<CrcConfigService, CrcConfigDOI.RowDataI, CrcConfigDOI.QueryRowDataParamsI> {
    @override
    renderHead(h) {
       return <div></div>
    }
    
    @override
    loadService () {
       this.service = new CrcConfigService(this)
    }
    
}
